import type { BackupPayload } from './userStore';

export async function saveBackupToCloud(
  payload: BackupPayload
): Promise<{ ok: true; code: string } | { ok: false; message: string }> {
  try {
    const res = await fetch('/api/backup', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = (await res.json()) as { code?: string; error?: string };
    if (!res.ok || !data.code) {
      return { ok: false, message: data.error || 'save_failed' };
    }
    return { ok: true, code: data.code };
  } catch {
    return { ok: false, message: 'network_error' };
  }
}

/** 既存の共有コードを同じキーで上書き更新 */
export async function updateBackupInCloud(
  code: string,
  payload: BackupPayload
): Promise<{ ok: true; code: string } | { ok: false; message: string }> {
  try {
    const res = await fetch('/api/backup', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...payload, code: code.trim().toUpperCase() }),
    });
    const data = (await res.json()) as { code?: string; error?: string };
    if (!res.ok || !data.code) {
      return { ok: false, message: data.error || 'update_failed' };
    }
    return { ok: true, code: data.code };
  } catch {
    return { ok: false, message: 'network_error' };
  }
}

export async function loadBackupFromCloud(
  code: string
): Promise<{ ok: true; payload: BackupPayload } | { ok: false; message: string }> {
  try {
    const normalized = code.trim().toUpperCase();
    const res = await fetch(`/api/backup?code=${encodeURIComponent(normalized)}`);
    const data = await res.json();
    if (!res.ok) {
      return { ok: false, message: (data as { error?: string }).error || 'not_found' };
    }
    const payload = data as BackupPayload;
    if (!payload || payload.version !== 2 || !payload.account) {
      return { ok: false, message: 'invalid_payload' };
    }
    return { ok: true, payload };
  } catch {
    return { ok: false, message: 'network_error' };
  }
}
